import { record } from 'rrweb';

import { objectOperator } from '../../utils/spread';

export class Module {
  constructor(aggregator, config) {
    this.aggregator = aggregator;
    this.config = config;
    this.recorder = null;
    this.isPaused = false;
  }

  record() {
    this.recorder = record({
      emit: this.emit.bind(this),
      ...this.config,
    });
  }

  emit(event) {
    if (this.isPaused) {
      return;
    }

    if (event.type === 4) {
      const metadata = this.aggregator.buildMetadataFromContext();

      event.data = objectOperator([{}, metadata.data, event.data]);
    }

    this.aggregator.incrementToContext(event);
  }

  stop() {
    this.recorder();
  }

  pause() {
    this.isPaused = true;
  }

  resume() {
    this.isPaused = false;
  }

  flush() {}
}
